import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useVessel, Vessel } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';
import { VesselStampPanel } from './StampPanel';

const Form: React.FC = () => (
  <GenericFormPage<Vessel>
    useData={useVessel}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
      renderEditFormExtra: ({ isEdit, data, id }) => {
        if (!isEdit || !id || !data) {
          return (
            <p className="mt-3 text-xs text-slate-500">
              Save the vessel first, then upload its official stamp on edit or detail.
            </p>
          );
        }
        return (
          <div className="mt-4">
            <VesselStampPanel
              vesselId={id}
              stampStorageKey={data.stampStorageKey}
              stampOriginalFilename={data.stampOriginalFilename}
              editable
            />
          </div>
        );
      },
    }}
  />
);

export default Form;
